import React, { useEffect, useState } from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';
import baseURL from '../../url';

const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export default function PedidosEntregadosChartBar() {
    const [data, setData] = useState([]);
    const [totalPedidos, setTotalPedidos] = useState(0);

    useEffect(() => {
        fetch(`${baseURL}/pedidoGet.php?resumen=entregados-mensual`)
            .then(res => res.json())
            .then(json => {
                if (Array.isArray(json)) {
                    const pedidosPorMes = MESES.map((mesNombre, idx) => {
                        const mesNum = idx + 1;
                        const mesData = json.find(item => parseInt(item.mes) === mesNum);
                        return {
                            mes: mesNombre,
                            total: mesData ? parseInt(mesData.total) : 0,
                        };
                    });
                    setData(pedidosPorMes);

                    // Sumar el total de pedidos entregados
                    const total = pedidosPorMes.reduce((acc, item) => acc + item.total, 0);
                    setTotalPedidos(total);
                } else {
                    setData(MESES.map(mes => ({ mes, total: 0 })));
                    setTotalPedidos(0);
                }
            })
            .catch(err => {
                console.error('Error cargando pedidos entregados por mes:', err);
                setData(MESES.map(mes => ({ mes, total: 0 })));
                setTotalPedidos(0);
            });
    }, []);

    return (
        <div style={{ width: '100%', height: 700, marginTop: 20 }}>
            <h3 style={{ textAlign: 'center' }}>
                📦 Pedidos <strong>entregados</strong> por mes
            </h3>

            <div style={{ width: '100%', height: 330, marginTop: 20 }}>
                <ResponsiveContainer>
                    <BarChart data={data} margin={{ top: 0, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="mes" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Bar dataKey="total" fill="#82ca9d" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
            <br />
            <br />
            <h3 style={{ textAlign: 'center', marginBottom: 20 }}>
                📋 Total de pedidos entregados: {totalPedidos.toLocaleString()}
            </h3>
        </div>
    );
}
